import {AnyObject} from 'types';

type Func = (value: string) => AnyObject | false;

type Predicate = Func | RegExp;

export function makeRules(templates: Predicate[]) {
  const predicates = templates.map(template => {
    if (typeof template === 'function') {
      return template;
    }
    return (value: string) => template.exec(value)?.groups;
  });
  return {
    match: (value: string) => {
      for (const predicate of predicates) {
        const result = predicate(value);
        if (result) {
          return result;
        }
      }
    }
  };
}
